import { render, staticRenderFns } from "./cardHome.vue?vue&type=template&id=20497f95&"
import script from "./cardHome.vue?vue&type=script&lang=js&"
export * from "./cardHome.vue?vue&type=script&lang=js&"
import style0 from "./cardHome.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports